import { useTranslation } from 'react-i18next';
import { withBase } from '@/utils/basePath';

/**
 * RF-011 — Punto de entrada a Reconocimiento (Shine Together / Brillamos Juntos) desde la home
 * de Pulso. Espeja a `GrowthBanner`: misma estructura y clases (`home-culture-*`), mismo sistema
 * de i18n (namespace `translation`, bloque `survey.recognition`).
 *
 * Reconocimiento vive en OTRO armazón (`src/router/AppRouter.tsx`, rutas `/app`), no en el router
 * SPA de Pulso. Por eso el CTA es una navegación de PÁGINA COMPLETA (`<a href="/app/reconocer">`)
 * y no un `onClick` de router: cambiar de armazón exige recargar la página.
 */
export function RecognitionBanner() {
  const { t } = useTranslation();

  return (
    <div className="home-culture-banner">
      <div className="home-culture-icon" aria-hidden="true">
        <i className="fas fa-award" />
      </div>
      <div className="home-culture-body">
        <p className="home-culture-title">{t('survey.recognition.title')}</p>
        <p className="home-culture-sub">{t('survey.recognition.message')}</p>
      </div>
      <a className="home-culture-cta" href={withBase('/app/reconocer')}>
        {t('survey.recognition.cta')}
        <i className="fas fa-arrow-right" aria-hidden="true" />
      </a>
    </div>
  );
}
